import React from 'react';
import { Grid, TextField } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

export default function ProcessorShopify({ processorSettings }) {
    const { t } = useTranslation('connector');

    return (
        <>
            <Grid item xs={12}>
                <TextField
                    fullWidth
                    disabled
                    id="connector-shop-id"
                    label={t('label.shop_id')}
                    variant="outlined"
                    value={processorSettings.shopId ?? ''}
                    InputProps={{ readOnly: true }}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    fullWidth
                    disabled
                    id="connector-shop-pass"
                    label={t('label.shop_pass')}
                    variant="outlined"
                    type="password"
                    value={processorSettings.shopPass ?? ''}
                    InputProps={{ readOnly: true }}
                />
            </Grid>
        </>
    );
}
